module.exports = __webpack_public_path__ + "static/mvv-design-9a371a26d2dd665e64f37ac0f0e1450d.png";